export const menu = {
    label: 'Expositores',
    icon: 'pi pi-users',
    to: '/checkins/expositores',
    matchChildren: true,
    rules: ['EXPOSITOR-00'],
};

export default menu;
